// The QL-700 prints from the browser on the employee's computer.
// Each 90 x 29 mm die-cut sticker holds two 45 x 29 mm samples.
const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, c => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
}[c]));

const half = sample => `<div class="half">
  <div class="sample-id">${escapeHtml(sample.id)}</div>
  <div class="company">${escapeHtml(sample.source || sample.client || '')}</div>
  <div class="description">${escapeHtml(sample.desc || '')}</div>
</div>`;

export function printSampleLabels(samples) {
  if (!Array.isArray(samples) || !samples.length) {
    throw new Error('No saved samples are available for labels.');
  }
  const popup = window.open('', '_blank');
  if (!popup) throw new Error('Allow pop-ups for this LIMS site and try Print Labels again.');
  const title = samples.length === 1
    ? `Sample ${samples[0].id} label`
    : `Work Order ${samples[0].workOrder || ''} labels`;
  const paired = [];
  for (let i = 0; i < samples.length; i += 2) {
    // The unmatched final sample is repeated, giving two usable halves.
    paired.push(`<article class="label">${half(samples[i])}${half(samples[i + 1] || samples[i])}</article>`);
  }
  const single = samples.map(sample => `<article class="label">${half(sample)}</article>`);
  const markup = `<!doctype html><html lang="en"><head><meta charset="utf-8">
    <title>${escapeHtml(title)}</title>
    <style id="page-style">@page { size: 90mm 29mm; margin: 0; }</style>
    <style>
      * { box-sizing: border-box; }
      body { margin: 0; font-family: Arial, sans-serif; color: #000; background: #f1f3f6; }
      .controls { position: sticky; top: 0; padding: 12px; background: #fff; border-bottom: 1px solid #aaa; }
      .controls button, .controls select { padding: 7px 10px; font: 14px Arial, sans-serif; }
      .controls small { display: block; margin-top: 6px; }
      .label { background: white; width: 90mm; height: 29mm; margin: 12px auto;
        display: flex; overflow: hidden; border: 1px solid #bbb;
        break-after: page; page-break-after: always; }
      .half { flex: 0 0 50%; min-width: 0; padding: 2mm 2.5mm; display: flex;
        flex-direction: column; justify-content: center; overflow: hidden; }
      .two-up .half:first-child { padding-left: 3.7mm; border-right: 1px dashed #555; }
      .sample-id { font-size: 16pt; font-weight: 800; line-height: 1.05; white-space: nowrap; }
      .company { font-size: 8pt; font-weight: 700; line-height: 1.15;
        overflow: hidden; overflow-wrap: anywhere; display: -webkit-box;
        -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
      .description { font-size: 8pt; line-height: 1.15; overflow: hidden;
        overflow-wrap: anywhere; display: -webkit-box;
        -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
      body:not(.small) .one-up, body.small .two-up { display: none; }
      body.small .label { width: 62mm; }
      body.small .half { flex-basis: 100%; padding: 2.5mm 3mm; }
      body.small .sample-id { font-size: 18pt; }
      body.small .company { font-size: 9pt; }
      @media screen {
        body { zoom: 2; }
      }
      @media print {
        body { background: white; zoom: 1 !important; }
        .controls { display: none; }
        .label { margin: 0; border: 0; }
        .two-up .label:last-child, .one-up .label:last-child {
          break-after: auto; page-break-after: auto;
        }
      }
    </style></head><body>
    <div class="controls"><label>Label roll: <select id="size">
      <option value="90">90 × 29 mm — two samples per sticker</option>
      <option value="62">62 × 29 mm — one sample per sticker</option>
    </select></label> <button id="print" type="button">Print ${paired.length} sticker(s)</button>
    <small>On 90 × 29 mm stickers, cut at the dotted middle line by hand. A single or unmatched last sample is printed on both halves.</small>
    <small>Select the Brother QL-700 and matching DK roll in your computer's print dialog. Set scale to 100% and margins to none.</small></div>
    <div class="two-up">${paired.join('')}</div>
    <div class="one-up">${single.join('')}</div>
    <script>
      document.getElementById('size').addEventListener('change', function () {
        const small = this.value === '62';
        document.body.classList.toggle('small', small);
        document.getElementById('page-style').textContent = '@page { size: ' + this.value + 'mm 29mm; margin: 0; }';
        document.getElementById('print').textContent = 'Print ' + (small ? ${samples.length} : ${paired.length}) + ' sticker(s)';
      });
      document.getElementById('print').addEventListener('click', function () { window.print(); });
    <\/script></body></html>`;
  popup.document.open();
  popup.document.write(markup);
  popup.document.close();
  // Keep the print call in the original button click's user gesture. Browsers
  // may suppress print dialogs requested later by timers in a new tab.
  popup.focus();
  popup.print();
  return { count: samples.length, stickers: paired.length };
}
